var formErrors = {};

const validate = (form, errors) => {
    var valid = true;
    formErrors = {};

    for (var i = 0; i < form.length; i++) {
        let result = validateSingle(form[i]);

        if (result !== true) {
            valid = false;
        }
    }

    // console.log(formErrors);
    return formErrors;

    return valid;
};

const validateSingle = nodeElement => {
    let valid = true;
    var name = nodeElement.getAttribute("data-name") != null ? nodeElement.getAttribute("data-name") : "";
    var minValue = nodeElement.getAttribute("data-length");
    var type = nodeElement.getAttribute("data-type");

    // verifica si es campo obligatorio
    if (
        nodeElement.hasAttribute("required") &&
        !nodeElement.hasAttribute("disabled")
    ) {
        error(nodeElement, ""); // limpia el error
        // verifica si el email es valido
        if (nodeElement.type == "email") {
            var regex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
            if (!regex.test(nodeElement.value)) {
                valid = false;
                error(nodeElement, "No es un email valido");
                if(typeof formErrors['email'] == 'undefined' || !formErrors['email'])
                    formErrors['email'] = "No es un email valido";
            }
        }

        // verifica si el campo esta completo
        if (minValue != null) {
            var length = nodeElement.value.length;
            if (length != minValue) {
                valid = false;
                error(nodeElement, "No es un " + name + " valido");
                if(typeof formErrors[name] == 'undefined' || !formErrors[name])
                    formErrors[name] = "No es un " + name + " valido";
            }
        }

        // verifica si el campo es un nombre
        if (type == "name") {
            var value = nodeElement.value.trim();
            nodeElement.value = value;
            if (!/^[A-Z a-z]+$/.test(value)) {
                valid = false;
                error(nodeElement, "El valor no es un nombre");
                if(typeof formErrors['nombre'] == 'undefined' || !formErrors['nombre'])
                    formErrors['nombre'] = "El valor no es un nombre";
            }
        }

        // verifica si el campo esta vacio
        if (nodeElement.value == "") {
            valid = false;
            error(nodeElement, name !== "" ? "El campo " + name + " es obligatorio" : "El campo es obligatorio");
            formErrors[name] = "El campo " + name + " es obligatorio";
        }

        if (nodeElement.type == "checkbox" && !nodeElement.checked) {
            valid = false;
            error(nodeElement, name !== "" ? "El campo " + name + " es obligatorio" : "El campo es obligatorio");
            formErrors[name] = "El campo " + name + " es obligatorio";
        }
    }

    return valid;
};

const error = (form, error) => {
    var parent = form.parentElement;
    var feedback = parent.querySelector(".form-feedback");
    if (feedback == null) {
        var el = document.createElement("span");
        el.classList.add("form-feedback");
        parent.appendChild(el);
        feedback = el;
        form.classList.add("form-error");
    }
    error == "" ?
        form.classList.remove("form-error") :
        form.classList.add("form-error");
    feedback.innerHTML = error;
    
    return error;
};

export default {
    error,
    validate,
    validateSingle,
    formErrors
};